import { PageImageTransformTypeEntity } from "@jackfruit/common"
import { createEntitySlice } from "../createEntitySlice"

export const {
  slice: pageImageTransformTypes,
  selectors: pageImageTransformTypesSelectors,
} = createEntitySlice<PageImageTransformTypeEntity>("pageImageTransformTypes")
